import React from 'react';
import { Billboard } from '@companycam/slab-web';
import { translate } from 'translations/i18n';
import styled from 'styled-components';
import { tokens } from '@companycam/slab-tokens';

const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin-bottom: ${tokens.size_spacing_xl}px;
`;

type MediaErrorBillboardProps = {
  refetchAction: () => void;
};

export default function MediaErrorBillboard({
  refetchAction,
}: MediaErrorBillboardProps) {
  return (
    <ErrorContainer>
      <Billboard
        title={translate('common.uhOh')}
        color="destroy"
        message={translate('showcase.wizard.media.error')}
        iconName="alert-circle"
        secondaryAction={{
          label: translate('common.tryAgain'),
          onClick: refetchAction,
        }}
      />
    </ErrorContainer>
  );
}
